import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';
import Swal from "sweetalert2";
import axios from "axios";
import {withTranslation} from 'react-i18next';
import i18n from "i18next";

class guest_checkout extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            open: false,
            customerId: this.props.match.params.custId,
            windowHeight: 0,
            customerToken: '',
            selectedCountry: 'State',
            swalButton: '',
            phone: '',
        };
        this.updateState = this.updateState.bind(this);
    };

    handleChange = e => {

        this.setState({phone: this.normalizeInput($(e.target).val(), this.state.phone)});
    };

    normalizeInput = (value, previousValue) => {
        if (!value) return value;
        var currentValue = value.replace(/[^\d]/g, '');
        var cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };
    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    updateState(e) {
        this.setState({});
    }

    updateCountryLabel = (e) => {
        var selectedOption = $(e.target).find('option:selected').text();
        $(e.target).next(".holder").text(selectedOption);
        this.setState({selectedCountry: selectedOption});
    };

    componentDidMount() {

        document.title = "Guest Checkout - " + localStorage.getItem("store_name") + " - Tria Commerce";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#cntCheckoutBtn').click(e => {

            var firstname = $('#custFirstNameTxt').val();
            var lastname = $('#custLastNameTxt').val();
            var email = $('#custEmailTxt').val();
            var phone = $('#custPhoneTxt').val();
            var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
            var address = $('#custAddressTxt').val();
            var city = $('#custCityTxt').val();
            var state = $('#custStateTxt :selected').val();
            var zip = $('#custZipTxt').val();

            if (firstname == '' ||
                firstname == null ||
                lastname == '' ||
                lastname == null ||
                phone == '' ||
                phone == null ||
                email == '' ||
                email == null) {


                this.state.swalButton.fire({title: i18n.t('field_validation'), allowOutsideClick: false});

                return;
            } else if (sessionStorage.getItem("orderType") == "D" && (address == '' ||
                address == null ||
                state == '' ||
                state == null ||
                city == '' ||
                city == null ||
                zip == '' ||
                zip == null)) {
                this.state.swalButton.fire({title: i18n.t('field_validation'), allowOutsideClick: false});

                return;
            } else if (!pattern.test(email)) {


                this.state.swalButton.fire({title: i18n.t('email_validation'), allowOutsideClick: false});
                return;
            } else if (!$('#termsChkBox').is(':checked')) {

                this.state.swalButton.fire({title: i18n.t('terms_and_conditions'), allowOutsideClick: false});

                return;
            }

            if (sessionStorage.getItem("orderType") == "D") {

                if (parseInt(localStorage.getItem("store_delivery_range")) > 0 && localStorage.getItem('store_latitude') != "" && localStorage.getItem('store_longitude') != "") {

                    var fulladdress = address + ", " + city + ", " + state + ", " + zip;

                    this.onOpenModal();

                    var url = API_ROOT + '/fetchdistance';

                    var options = {
                        address: fulladdress,
                        latitude: localStorage.getItem("store_latitude"),
                        longitude: localStorage.getItem("store_longitude"),
                        distance: localStorage.getItem("store_delivery_range"),
                    };

                    axios.post(url, options).then(response => {

                        this.onCloseModal();

                        if (response.data.status == 1) {

                            var dbconn = new db();
                            dbconn.set({
                                customer_firstname: firstname,
                                customer_lastname: lastname,
                                customer_email: email,
                                customer_phone: phone,
                                customer_address: address,
                                customer_state: state,
                                customer_city: city,
                                customer_zip: zip
                            });
                            this.setState({redirect: true});
                        } else {

                            this.state.swalButton.fire({
                                title: response.data.message,
                                allowOutsideClick: false
                            });
                        }
                    }).catch(function (error) {
                        this.onCloseModal();
                        console.log(error);
                    });

                } else {
                    var dbconn = new db();
                    dbconn.set({
                        customer_firstname: firstname,
                        customer_lastname: lastname,
                        customer_email: email,
                        customer_phone: phone,
                        customer_address: address,
                        customer_state: state,
                        customer_city: city,
                        customer_zip: zip
                    });
                    this.setState({redirect: true});
                }


            } else {

                var dbconn = new db();
                dbconn.set({
                    customer_firstname: firstname,
                    customer_lastname: lastname,
                    customer_email: email,
                    customer_phone: phone,
                    customer_address: address,
                    customer_state: state,
                    customer_city: city,
                    customer_zip: zip
                });
                this.setState({redirect: true});
            }


        });
    }

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });


        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (data && data.length > 0) {

                $('#custFirstNameTxt').val(data[0].customer_firstname);
                $('#custLastNameTxt').val(data[0].customer_lastname);
                $('#custEmailTxt').val(data[0].customer_email);
                $('#custPhoneTxt').val(data[0].customer_phone);
                $('#custAddressTxt').val(data[0].customer_address);
                $('#custStateTxt').val(data[0].customer_state);
                $('#custCityTxt').val(data[0].customer_city);
                $('#custZipTxt').val(data[0].customer_zip);

                if (data[0].customer_state == "") {

                    this.setState({selectedCountry: 'State'});
                } else {

                    this.setState({selectedCountry: data[0].customer_state});
                }

            }
        });
    }


    render() {

        const {open} = this.state;
        const {t} = this.props;
        if (this.state.redirect) {
            return <Redirect to='/checkout/card'/>;
        }


        var orderType = "visible";

        if (sessionStorage.getItem("orderType") == "P" || sessionStorage.getItem("orderType") == "I" || sessionStorage.getItem("orderType") == "C") {
            orderType = "none";
        }


        return (
            <div className="mainContainer">
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to="/order/view"></Link>
                        <h2 className="text-center"><strong>{t('guest_checkout')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white h-100 middleContent" style={{
                    height: "100vh", position: "fixed",
                    width: "100%"
                }}>
                    <div className="simple-box m-b-0 p-b-35 bkg-white m-grey full-height"
                         style={{height: "100vh", paddingBottom: "150px", overflowY: "scroll"}}>
                        <div className="form-box w-75 div-center m-b-15 form-box-red m-w-100">
                            <form name="" className="float_l w-100" method="post" encType="multipart/form-data"
                                  action="#">
                                <div className="header-title m-b-0 m-t-25">
                                    <h2 className="text-center font-size-20 m-0">{t('guest_checkout_info')}</h2>
                                </div>
                                <div className="form-group  m-label-none m-t-25">
                                    <label>{t('first_name')}*</label>
                                    <input type="text" className="form-control m-w-100 float_l" name="custFirstNameTxt"
                                           id="custFirstNameTxt" required/>
                                </div>
                                <div className="form-group m-label-none">
                                    <label>{t('last_name')}*</label>
                                    <input type="text" className="form-control m-w-100 float_r m-r-0"
                                           name="custLastNameTxt" id="custLastNameTxt"
                                           required/>
                                </div>
                                <div className="form-group m_b_10 m-label-none">
                                    <label>{t('email_address')}*</label>
                                    <input type="text" className="form-control m-b-2" name="custEmailTxt"
                                           id="custEmailTxt"
                                           required/>
                                    <small className="desk-block">{t('we_never_share_your_email')}</small>
                                </div>
                                <div className="form-group m_b_10 m-label-none">
                                    <label>{t('phone_number')}*</label>
                                    <input type="text" className="form-control m-b-2" name="custPhoneTxt"
                                           id="custPhoneTxt"
                                           value={this.state.phone || ''}
                                           onChange={this.handleChange} required/>
                                    <small className="desk-block">{t('phone_disclaimer')}</small>
                                </div>
                                <div className="form-group m-label-none" style={{display: orderType}}>
                                    <label>{t('address')}</label>
                                    <input type="text" className="form-control" name="custAddressTxt"
                                           id="custAddressTxt"
                                           required/>
                                </div>
                                <div className="form-group m-label-none" style={{display: orderType}}>
                                    <label>{t('city')}</label>
                                    <input type="text" className="form-control" name="custCityTxt" id="custCityTxt"
                                           required/>
                                </div>
                                <div className="form-group m-label-none m-b-2" style={{display: orderType}}>
                                    <label>{t('state')}</label>
                                    <select className="form-control custom-select" id="custStateTxt" name="custStateTxt"
                                            required onChange={this.updateCountryLabel}>
                                        <option value="">{t('select_any')}</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select>
                                </div>
                                <div className="form-group m-label-none m-b-2" style={{display: orderType}}>
                                    <label>{t('zip_code')}</label>
                                    <input type="text" className="form-control" name="custZipTxt" id="custZipTxt"
                                           required/>
                                </div>

                                <div className="form-group">
                                    <label className="ch_box"><small>{t('age_disclaimer')} <Link to={'/terms'}
                                                                                                 className="underline">{t('terms_link')}</Link>.
                                    </small>
                                        <input type="checkbox" id="termsChkBox" name="termsChkBox"/>
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                                <div className="form-group m-t-30 btn-red w-72p">

                                    <input type="button" name="cntCheckoutBtn" id="cntCheckoutBtn"
                                           value={t('continue_to_checkout')}/>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('checking_out')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(guest_checkout));


// WEBPACK FOOTER //
// ./src/view_components/guest_checkout.js